var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 7,
    width: 46,
    height: 34,
    rx: 3,
    ry: 3,
    fill: "#243747"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 24,
    r: 8,
    fill: "#e61c24"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.934,
    cy: 24,
    r: 8,
    fill: "#f99f1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.967,17.736h0a7.985,7.985,0,0,0,0,12.528h0a7.985,7.985,0,0,0,0-12.528Z",
    fill: "#f26622"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.db8da67868d65dffc4200d0c75120aed.svg";
export { ForwardRef as ReactComponent };